import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../Form/Button';
import { useCartContext } from '../../../Contexts/CartContext';
import { HiXMark } from 'react-icons/hi2';
import { TbShoppingBagPlus } from 'react-icons/tb';
import { METHOD_PAYMENT_TYPE_PIX } from '../../../Utils/Constants/Checkout';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { useStoreHook } from '../../../Hooks/StoreHook';
import GooglePayButton, { GooglePayParamsProps } from '../../Form/GooglePayButton';

interface ButtonsCheckoutProps {
	disabledFinish: boolean;
	onCancel: CallableFunction;
	label: string;
	method: any;
	onFinishOrder: CallableFunction;
	cart?: any;
	isGooglePay: boolean
	onCreateOrderWithGooglePay: CallableFunction;
	onCancelGooglePay: CallableFunction;
}

const ButtonsCheckout = ({
	disabledFinish,
    label,
    method,
    onCancel,
    onFinishOrder,
    cart,
    isGooglePay = false,
    onCreateOrderWithGooglePay,
    onCancelGooglePay
	}: ButtonsCheckoutProps) => {

    const navigate = useNavigate();
    const { setReturnToCheckout, loadingUpdateQuantity } = useCartContext();
    const { getLinkToHome } = useStoreHook();

    const handleFinishOrder = () => {
    	onFinishOrder()
    }

    const handleAddProduct = () => {
		navigate(getLinkToHome());
		setReturnToCheckout(true);
    }

    return (
		<>
			<Button rounded onClick={handleAddProduct}>
				<div><TbShoppingBagPlus size={20} /></div>
			</Button>

			<div className='w-full justify-start'>
				{/* GooglePay button */}
				{isGooglePay &&
					<GooglePayButton
						method={method}
						valueTotal={cart?.total_with_discount ?? 0}
						onCreateOrder={(e: GooglePayParamsProps) => onCreateOrderWithGooglePay(e)}
						onCancel={() => onCancelGooglePay()}
						loading={loadingUpdateQuantity}
					/>
				}

				{/* Default button */}
				{!isGooglePay &&
					<ButtonPrimary
						disabled={disabledFinish || loadingUpdateQuantity}
						onClick={() => handleFinishOrder()}
						className={`
						${method?.type === METHOD_PAYMENT_TYPE_PIX && 'ring-teal-400 bg-teal-400 text-white hover:bg-teal-500 hover:ring-teal-500'}
						w-full xs:max-w-sm md:max-w-xs gap-1 text-nowrap`}
						>
						{label}
					</ButtonPrimary>
				}
			</div>

			<Button rounded onClick={() => onCancel()}>
				<div><HiXMark size={20} /></div>
			</Button>
      	</>
	)
}

export default ButtonsCheckout;